import { ResetPasswordViewModel } from "@authentication/presentation/pages/login/form/reset-password.form.viewmodel";
import { LoginPageViewModel } from "@authentication/presentation/pages/login/login-page.viewmodel";
import { DiModuleBuilder } from "@iot-platform/core";
import { ContainerModule } from "inversify";

const webAuthenticationModule = new DiModuleBuilder();

webAuthenticationModule.registerSubModules(() => ({
    viewModels: new ContainerModule(({ bind }) => {
        bind(LoginPageViewModel).toSelf();
        bind(ResetPasswordViewModel).toSelf();
    }),
}));

webAuthenticationModule.registerModule();

export { webAuthenticationModule };
